/***
**Module Name: Partners
 **File Name :  partners.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 27 2022
 **Last modified on: Dec 27 2022
 **Description : contains team page details.
 ***/
 import React, { useEffect, useState, useContext } from "react";

 // import "../../src/assets/css/style.css"
 import tmdbApi from "../api/tmdbApi";
 import Header from "../components/header/Header";
 import Footer from "../components/footer/Footer";
 import ReactHtmlParser from 'react-html-parser';
 import SessionPopup from "./SessionPopup";
 import $ from "jquery";
 import axios from "axios";
 
 import * as Config from "../constants/Config";
 import { contentContext } from "../context/contentContext";
 import Loader from "../components/loader"
 import Modal from 'react-bootstrap/Modal';
 import moment from "moment";
 
 import InsideHeader from "../components/InnerHeader/Header";
 let { lambda, appname } = window.app;
 
 const News = () => {
 
   const [config, setConfig] = useState({});
   const [teamBoard, setTeamBoard] = useState({});
   const [teamMember, setTeamMember] = useState({});
   const [newsData, setNewsData] = useState([]);
   const [singleNewsData, setSingltNewsData] = useState([]);
   const [about, setAbout] = useState('');
   const [showSessionPopupup, setShowSessionPopupup] = useState(false);
 
   const [show, setShow] = useState(false)
   const { menus, setContentSearchFlag, isLoading, setIsLoading, sorting,newsPerPageConst, setNewsPerPageConst, setSorting, newspageNumber, setNewsPageNumber, newsperpage, setNewsPerpage, newsAssetTotal, setNewsAssetTotal, newsTotalPages, setNewsTotalPages, newstotalPagesArray, setNewsTotalPagesArray, contentSearchFlag, setRoute } = useContext(contentContext);
   const [showDescription, setShowDescription] = useState(false);
   const [btnLoader, setBtnLoader] = useState(false);
   const [partnersData, setPartnersData] = useState([]);
 
   useEffect(() => {
     if (window.site) {
       setConfig(window.site);
 
     }
     setContentSearchFlag(false)
     setRoute("notcontent")
   }, [window.site]);
 
   if (config.common && config.common.imagesCDN) {
     var img = config.common.imagesCDN;
   }
   
   useEffect(() => {
     {
       menus && menus.length > 0 && menus.map(function (item, i) {
         if (item.menuid === 100003) {
           setTeamBoard(item.team[0].members);
           setTeamMember(item.team[1].members)
         }
       })
     }
 
   }, [menus]);
 
 
   useEffect(() => {
 
     news()
     clientActivity()
   }, [newsperpage, newspageNumber, sorting])
   const clientActivity = () => {
     let path = window.location.pathname.split("/");
     // const pageName = path[path.length - 1];
     var presentTime = moment();
     let payload;
 
     payload = {
       "clientid": localStorage.getItem("clientid"),
       "pagename": 'PARTNERS',
       "pageurl": window.location.href,
       "starttime": presentTime,
       "useragent": JSON.parse(localStorage.getItem("loc"))
 
     };
 
 
     let urlLink;
     if (localStorage.getItem("previousid")) {
       urlLink = lambda + '/activity?appname=' + appname + "&previousid=" + localStorage.getItem("previousid")
     } else {
       urlLink = lambda + '/activity?appname=' + appname
     }
 
     axios({
       method: 'POST',
       url: urlLink,
       data: payload
     })
       .then(function (response) {
         if (response.data.statusCode === 200) {
           localStorage.setItem("previousid", response.data.result)
         }
       });
   }
 
   const handleSortBy = (e) => {
     const selectedValue = e.target.value; // Get the selected value
     setSorting(selectedValue);
 
     // Send the sorting value (e.g., to an API or another function)
 
   };
   const defaultImageUrl = img+"orasi/client/resources/orasiv1/images/newsDefaultwhite.png";
 
 
   const handleClose = () => {
     setShow(false)
   }
   const handleClick = async (Id) => {
     setShow(true)
     const token = localStorage.getItem("token");
     const userid = localStorage.getItem("userId");
 
     try {
       setIsLoading(true)
       // setIsLoading2(true); // Start loading
 
       // Make API call
       const response = await axios.post(`${lambda}/news?appname=${appname}&userid=${userid}&newsid=${Id}${token ? `&token=${token}` : ''}`);
 
       console.log("S3 Response: ", response);
 
 
       // Set content data if response is valid
       // const newsData = response?.data?.result?.data?.[0];
       // setEditContent(newsData);
       // setValue(newsData?.description);
       // setDefaultImage(newsData?.defaultimage);
       console.log("responseeeeeeeeeeeeeee", response)
       setSingltNewsData(response?.data?.result?.data?.[0])
       setIsLoading(false)
       // setIsLoading2(false); // Stop loading after API call
     } catch (error) {
       console.error("Error during API call:", error);
       // setIsLoading2(false); // Stop loading in case of error
     }
   }
   const calculateTimeAgo = (date) => {
     const now = new Date();
     const past = new Date(date);
 
     // Calculate the difference in time in milliseconds
     const timeDifference = now - past;
 
     // Calculate the difference in days
     const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
 
     // Define constants for months and years
     const daysInMonth = 30;
     const daysInYear = 365;
 
     if (daysDifference >= daysInYear) {
       const yearsAgo = Math.floor(daysDifference / daysInYear);
       return `${yearsAgo} year${yearsAgo !== 1 ? 's' : ''} ago`;
     } else if (daysDifference >= daysInMonth) {
       const monthsAgo = Math.floor(daysDifference / daysInMonth);
       return `${monthsAgo} month${monthsAgo !== 1 ? 's' : ''} ago`;
     } else if (daysDifference >= 1) {
       return `${daysDifference} day${daysDifference !== 1 ? 's' : ''} ago`;
     } else {
       const hoursAgo = Math.floor(timeDifference / (1000 * 60 * 60));
       return `${hoursAgo} hour${hoursAgo !== 1 ? 's' : ''} ago`;
     }
   };
 
   const previousClick = (e) => {
  
    const k=parseInt(newspageNumber)
     setNewsPageNumber( k- 1)
   }
   const handleNext = (e) => {
    const k=parseInt(newspageNumber)
     setNewsPageNumber(k + 1)
   }
  
   const handlePagechange = (e) => {
     let name = e.target.name;
     let value = e.target.value;
     if (name === "pageNo") {
       setNewsPageNumber(value)
       
     }
 
 
     if (name === "perPage") {
      
       setNewsPerpage(parseInt(value))
       setNewsPageNumber(1)
     }
   }
 
   
   const news = async () => {
     const token = localStorage.getItem("token");
     const userid = localStorage.getItem("userId");
     const sortBy = sorting;
     const pageNumber = newspageNumber;
     const assetcount = newsperpage;
 
     try {
       setIsLoading(true);
       const response = await axios({
         method: 'post',
         url: `${lambda}/news`,
         params: { appname, token, userid, sortBy, pageNumber, assetcount }, // Use params for query parameters in GET requests
         headers: {
           'Content-Type': 'application/json'
         }
       });
 
       if (response?.data?.result === "Invalid token or Expired") {
         setShowSessionPopupup(true)
       } else {
         // console.log(response?.data?.result)
         setIsLoading(false);
         if(response?.data?.result?.data?.length>0){
  let assetTotal = response?.data?.result?.totalcount
           || 0
         setNewsData(response?.data?.result?.data)
         setNewsAssetTotal(assetTotal)
 
         let totalPages = assetTotal / newsperpage;
 
         totalPages = Math.ceil(totalPages)
         console.log("totalPages--------------->", totalPages)
         let totalArray = [];
         for (var i = 0; i < totalPages; i++) {
           totalArray.push(i + 1)
         }
         console.log("totalllllllllllllllllllllllll", totalArray)
         setNewsTotalPagesArray(totalArray)
         setNewsTotalPages(totalPages)
         }
        
         // setIsLoading(false)
         // setNoDataMsg(false)
 
 
       }
 
       // setData(response?.data?.result?.data)
 
     } catch (error) {
       console.error('Error fetching news:', error);
       // setIsLoading(false); // Ensure this is called in case of an error
     } finally {
       // setIsLoading(false); // Ensure this is called to stop loading spinner regardless of success or failure
     }
   };
   const handleDescription = (e, item) => {
     setAbout(item)
     setShowDescription(!showDescription)
   }
 
   //  const img= "https://orasi.imgix.net/orasi/client/resources/orasiv1/images";
   // const cardWidth = $(".team-card-img-block").width();
   const cardWidth1 = $(".slider-section").width();
   const cardWidth = $(".main_thumb").width();
   return (
 
 
     <>
       <Modal show={showDescription} onHide={handleDescription} className="modal title-des-popup" id="descriptionPopup" >
         <Modal.Header closeButton>
           <Modal.Title>About</Modal.Title>
         </Modal.Header>
         <Modal.Body>
 
           <p style={{ whiteSpace: "pre-line" }}>{about}</p>
 
         </Modal.Body>
 
 
       </Modal>
       {showSessionPopupup && <SessionPopup />}
       {/* <Header menus={menus} activeClass={"100009"} /> */}
       {localStorage.getItem("token") ? <InsideHeader activeClass={"6"} /> : <Header menus={menus} activeMenu={"news"} activeClass={"100010"} />}
      <main id="main">
  {isLoading ? (
    <div className="orasi-preloader" id="news-preloader">
      <img
        id="preloader-img"
        src="https://d2aif2zmoi437u.cloudfront.net/orasi/common/images/preloader.png"
        alt="Loading preloader"
      />
    </div>
  ) : newsData?.length > 0 ? (
    <div className="section inner-container news_blogs" id="news-section">
      <div
        className="container aos-init aos-animate"
        data-aos="fade-up"
        id="news-container"
      >
        <div
          className="d-flex align-items-center justify-content-center mt-3"
          id="news-header"
        >
          <h1 className="sec-heading" id="news-heading">
            <span>NEWS</span>
            <select
              id="sort-by"
              className="form-control select form-select"
              name="sortBy"
              placeholder="sortBy"
              onChange={handleSortBy}
              value={sorting}
            >
              <option value="ascending">Newest</option>
              <option value="descending">Oldest</option>
            </select>
          </h1>
        </div>

        <div className="row" id="news-row">
          {newsData?.map((item) => (
            <div
              key={item?.newsid}
              id={`news-card-${item?.newsid}`}
              className="col-md-3 block"
            >
              <div
                className="main_thumb"
                id={`news-thumb-${item?.newsid}`}
                onClick={() => handleClick(item?.newsid)}
                style={{ cursor: "pointer" }}
              >
                <div className="img-dummy" id={`news-dummy-${item?.newsid}`} />
                <img
                  id={`news-img-${item?.newsid}`}
               src={
  (() => {
    const img = item?.defaultimage;

    if (typeof img === "string" && img.trim() !== "") {
      if (img.startsWith("https")) {
        return `${img}?auto=compress,format&width=${cardWidth}`;
      } else {
        return `${window?.site?.common?.imagesCDN || ""}${img}?auto=compress,format&width=${cardWidth}`;
      }
    }

    // fallback if img is not a string or empty
    return `${defaultImageUrl}?auto=compress,format&width=${cardWidth}`;
  })()
}




                  className="asset-portrait-thumb"
                  alt={item?.title ? `${item.title} thumbnail` : "News thumbnail"}
                />
              </div>

              <div className="thumb-content" id={`news-content-${item?.newsid}`}>
                <div
                  className="newsthumb-heading"
                  id={`news-title-wrapper-${item?.newsid}`}
                  onClick={() => handleClick(item?.newsid)}
                  style={{ cursor: "pointer" }}
                >
                  <h1 className="thumb-heading" id={`news-title-${item?.newsid}`}>
                    {item?.title}
                  </h1>
                </div>
                <div
                  className="newsthumb-body"
                  id={`news-body-${item?.newsid}`}
                >
                  <p className="news-description" id={`news-desc-${item?.newsid}`}>
                    {ReactHtmlParser(item?.description?.slice(0, 370))}
                  </p>
                </div>
                <div
                  className="newsthumb-footer"
                  id={`news-footer-${item?.newsid}`}
                >
                  <p
                    className="mt-2 fst-italic"
                    id={`news-date-${item?.newsid}`}
                  >
                    {calculateTimeAgo(item?.created)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {newsAssetTotal > newsPerPageConst && (
          <div className="row pagenation pgn1" id="news-pagination">
            <div className="pagenation_prv">
              <button
                id="pagination-prev"
                disabled={newspageNumber === 1}
                className="jr-btn btn-white btn btn-default btn-block"
                onClick={previousClick}
              >
                Previous
              </button>
            </div>
            <div className="pagenation_page">
              <label>Page :</label>
              <select
                id="pagination-pageNo"
                className="form-control custom-select u-w60 custom-select-sm form-control form-control-sm form-select"
                name="pageNo"
                value={newspageNumber}
                onChange={handlePagechange}
              >
                {newstotalPagesArray?.map((page) => (
                  <option key={`page-${page}`} value={page}>
                    {page}
                  </option>
                ))}
              </select>
              <label>
                <strong> of {newsTotalPages}</strong>
              </label>
            </div>
            <div className="pagenation_count" id="pagination-count">
              <label>
                {newspageNumber * newsperpage >= newsAssetTotal
                  ? newsAssetTotal
                  : newspageNumber * newsperpage}{" "}
                of {newsAssetTotal}
              </label>
            </div>
            <div className="pagenation_perpage">
              <label>Per Page:</label>
              <select
                id="pagination-perpage"
                className="form-control custom-select u-w60 custom-select-sm form-control form-control-sm form-select"
                name="perPage"
                onChange={handlePagechange}
                value={newsperpage}
              >
                {[12, 24, 36, 48, 60, 72, 84, 96].map((num) => (
                  <option key={`perpage-${num}`} value={num}>
                    {num}
                  </option>
                ))}
              </select>
            </div>
            <div className="pagenation_next">
              <button
                id="pagination-next"
                disabled={newspageNumber === newsTotalPages}
                className="jr-btn btn-white btn btn-default btn-block"
                onClick={handleNext}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      <Modal className="news-modal-popup" id="news-modal" show={show}>
        <div className="modal-body" id="modal-body">
          <div className="header-title" id="modal-header">
            <h5 className="modal-title popup-title" id="modal-title">
              {singleNewsData?.title}
            </h5>
            <button
              id="modal-close-btn"
              type="button"
              className="pop_close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span
                className="material-symbols-outlined"
                id="modal-close-icon"
                onClick={handleClose}
              >
                close
              </span>
            </button>
          </div>
          <div
            className="d-flex align-items-center justify-content-between mt-2 mb-2 created"
            id="modal-meta"
          >
            <p id="modal-createdBy">
              Created by {singleNewsData?.createdBy?.username}
            </p>
            <p id="modal-createdDate">
              {calculateTimeAgo(singleNewsData?.created)}
            </p>
          </div>

          <div className="row rev" id="modal-content">
            <div className="col-md-6">
              <p className="text-overflow" id="modal-description">
                {ReactHtmlParser(singleNewsData?.description)}
              </p>
              <div
                className="d-flex align-items-center social_media"
                id="modal-social"
              >
                {singleNewsData?.socialmedia?.linkedin && (
                  <a
                    id="social-linkedin"
                    href={singleNewsData.socialmedia.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`${img}orasi/admin/resources/orasiv1/images/linkedin.png`}
                      alt="LinkedIn"
                    />
                  </a>
                )}
                {singleNewsData?.socialmedia?.twitter && (
                  <a
                    id="social-twitter"
                    href={singleNewsData.socialmedia.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`${img}orasi/admin/resources/orasiv1/images/twitter.png`}
                      alt="Twitter"
                    />
                  </a>
                )}
                {singleNewsData?.socialmedia?.facebook && (
                  <a
                    id="social-facebook"
                    href={singleNewsData.socialmedia.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`${img}orasi/admin/resources/orasiv1/images/facebook.png`}
                      alt="Facebook"
                    />
                  </a>
                )}
                {singleNewsData?.socialmedia?.youtube && (
                  <a
                    id="social-youtube"
                    href={singleNewsData.socialmedia.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`${img}orasi/admin/resources/orasiv1/images/youtube-logo.png`}
                      alt="YouTube"
                    />
                  </a>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="slider-section" id="modal-slider">
                <ul id="modal-slider-list">
                  {singleNewsData?.images?.length > 0 ? (
                    singleNewsData.images.map((image) => (
                      <li key={image?.filepath} id={`modal-slider-item-${image?.filepath}`}>
                        <img
                          id={`modal-img-${image?.filepath}`}
                          src={`${window?.site?.common?.imagesCDN}${image.filepath}?auto=compress,format&width=${cardWidth1}`}
                          alt={`${singleNewsData?.title || "News"} image`}
                        />
                      </li>
                    ))
                  ) : (
                    <li id="modal-slider-item-default">
                      <img
                        id="modal-img-default"
                        src={`${defaultImageUrl}?auto=compress,format&width=${cardWidth1}`}
                        alt="Default news image"
                      />
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  ) : (
    <div className="section inner-container nodata-found" id="news-nodata">
      <div className="searchfail-block" id="searchfail-block">
        <img
          id="searchfail-img"
          src="https://d2aif2zmoi437u.cloudfront.net/orasi/common/images/search-fail.png"
          className="searchfail-graphic mt-5"
          alt="No News"
        />
        <h6 id="searchfail-title">No News Updates Yet</h6>
        <p id="searchfail-msg">
          Please stay tuned while Orasi team is working on it
        </p>
      </div>
    </div>
  )}
</main>

 
 
       <Footer menus={menus} />
     </>
   );
 };
 
 export default News;